import React from 'react';

import PropTypes from 'prop-types';
import { FaChevronLeft } from 'react-icons/fa';
import cn from 'classnames';
import { useHistory } from 'react-router-dom';

import { Text, IconButton } from 'modules/common';

function PageContent({
  label,
  children,
  withGoBack,
  containerClassName,
  isFormUnSavedAlertDirty,
}) {
  const history = useHistory();

  const handleOnGoBack = () => {
    history.goBack();
  };

  return (
    <div
      className={cn(
        'container mx-auto flex flex-col py-ds-16 md:py-[32px] flex-1 gap-ds-20',
        containerClassName,
        {
          '!pb-24': isFormUnSavedAlertDirty,
        }
      )}
    >
      {(withGoBack || label) && (
        <div className="flex items-center gap-ds-16">
          {withGoBack && (
            <IconButton
              icon={<FaChevronLeft className="h-4 w-4" />}
              onClick={handleOnGoBack}
            />
          )}

          {label && (
            <Text type="page-title" weight="bold">
              {label}
            </Text>
          )}
        </div>
      )}

      <div className="flex flex-col gap-ds-8 flex-1">{children}</div>
    </div>
  );
}

PageContent.defaultProps = {
  children: <></>,
  label: '',
  withGoBack: false,
  isFormUnSavedAlertDirty: false,
  containerClassName: '',
};

PageContent.propTypes = {
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  withGoBack: PropTypes.bool,
  isFormUnSavedAlertDirty: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
    PropTypes.string,
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
  ]),
};

export default PageContent;
